import { render } from "./AppSidebarItems.vue?vue&type=template&id=0630ef7a"
import script from "./AppSidebarItems.vue?vue&type=script&lang=js"
export * from "./AppSidebarItems.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__